import { render } from "./TagBtn.vue?vue&type=template&id=36336edd"
import script from "./TagBtn.vue?vue&type=script&lang=js"
export * from "./TagBtn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TagBtn.vue?vue&type=style&index=0&id=36336edd&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/tex/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__